export class InvState {
    id: number;
    code: string;
    name: string;
    parentCode: string;
    mask: string;
    isDeleted: boolean;
    state: any;
}